import { useNavigate, useParams } from "react-router-dom";
import "./StudentCard.css";
import React, { useContext, useState } from "react";
import PrimaryButton from "../../../Atoms/Buttons/Primary/PrimaryButton";
import { images } from "../../../../Assets/assetsHelper";
import useDelete from "../../../../Hooks/useDelete";
import { BaseURL, classesURL } from "../../../../Hooks/URL";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import DeleteForm from "../../../Molecules/DeleteForm/DeleteForm";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import { userContext } from "../../../../Contexts/userContext";
import useSave from "../../../../Hooks/useSave";

function StudentCard({
  role,
  Class,
  student,
  isTerminated,
  feedback = false,
  feedbackId,
}) {
  const navigate = useNavigate();
  const { contextData } = useContext(userContext);
  let { id } = useParams();
  const [go, setGo] = useState(false);
  const { saveState } = useSave({
    url: `${classesURL}/${id}/students/remove`,
    goSave: go,
    setGoSave: setGo,
    newObject: {
      studentIds: [student?.id],
    },
    refreshAfter: true,
  });
  return (
    <div
      key={student?.id}
      className="studentCard"
      // onClick={() => navigate(`/students/${student.id}`)}
    >
      <div className="studentAvatar">
        {student?.photoFilePath ? (
          <img
            alt="student photo"
            src={`${BaseURL}/${student?.photoFilePath}`}
            className="studentPhoto"
          />
        ) : (
          <div className="studentLogoPlaceholderSmall">
            <PersonIcon style={{ fontSize: "48px" }} />
          </div>
        )}
      </div>

      <div className="studentInfo">
        <h3 className="studentNameMeduim">{student?.name}</h3>
      </div>

      <div className="studentActions">
        {feedback ? (
          !student?.feedback ? (
            <button
              className="actionButton primary"
              onClick={() =>
                navigate(
                  `/classes/${Class?.id}/reports/${feedbackId}/student/${student?.id}/add`
                )
              }
              title="Add feedback"
            >
              Add Feedback
            </button>
          ) : (
            <button
              type="button"
              className="actionButton primary1"
              onClick={() =>
                navigate(
                  `/classes/${Class?.id}/reports/${feedbackId}/student/${student?.id}/feedback/${student?.feedback?.id}`
                )
              }
              title="View feedback"
            >
              View Feedback
            </button>
          )
        ) : (
          <>
            <button
              className="actionButton primary"
              onClick={() => navigate(`/students/${student?.id}`)}
              title="View student"
            >
              View Student
            </button>

            {!isTerminated && (role == "admin" || role == "school") ? (
              <DeleteForm
                setGo={setGo}
                title={`Are you sure to remove ${student?.name} from this class?`}
                classes="actionButton secondary"
                buttonText={"Remove"}
              />
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}

export default StudentCard;
